import { ConnectionOptionPropertyModel, IConnectionOptionPropertyModel } from '@rift/models/restapi/ConnectionOptionProperty.Model';
import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export interface IConnectionProviderOptionModel extends IRestModel {
    name: string;
    properties: Array<IConnectionOptionPropertyModel>;
}

export class ConnectionProviderOptionModel extends BaseModel implements IConnectionProviderOptionModel, IRestModel {
    public readonly isIRestModel = true;

    public name: string = null;
    public properties: Array<ConnectionOptionPropertyModel> = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-ConnectionProviderOptionModel');

        this.properties = RestModelUtility.loadFromArray(restModel.Properties, ConnectionOptionPropertyModel);
    }

    public toRestApiModel(): any {
        return {
            ...RestModelUtility.toJson(this),
            Properties: RestModelUtility.toJsonArray(this.properties),
        };
    }
}
